import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Form from 'root/module/form';
import Modals from 'root/modals';
import View from 'root/view/base';

var Jira_Send = View.extend({
    send_options: null,
    fields: {},

    project_key : null,
    issue_type  : null,

    form_value : {
        summary: '',
        description: ''
    },

    system_fields: ['project', 'issuetype', 'priority', 'summary', 'reporter', 'assignee', 'environment', 'labels', 'components'],
    system_fields_hidden: ['description', 'issuelinks', 'attachment'],

    views: {
        fields: {}
    },

    events: {
        'keyup input[name="summary"]'        : 'onChangeSummary',
        'keyup textarea[name="description"]' : 'onChangeDescription',
        'click .dropdown-projects li'        : 'onSelectProject',
        'click .dropdown-issue-types li'     : 'onSelectIssueType',
        'click .reconnect'                   : 'onReconnect',
        'submit form'                        : 'onSubmit'
    },

    dom_handlers: {
        onChangeSummary: function(e) {
            this.form_value.summary = $(e.currentTarget).val().trim();
        },

        onChangeDescription: function(e) {
            this.form_value.description = $(e.currentTarget).val().trim();
        },

        onSelectProject: function(e) {
            this.project_key = $(e.currentTarget).data('key');
            this.issue_type  = this.send_options.projects[this.project_key].issueTypes[0].name;

            this.createFieldViews();
            this.render();
        },

        onSelectIssueType: function(e) {
            this.issue_type = $(e.currentTarget).data('name');

            this.createFieldViews();
            this.render();
        },

        onReconnect: function() {
            Modals.activateJira();
        },

        onSubmit: function(e) {
            var form_data = Form.getData(this.$el.find('form'));

            form_data = _.extend(form_data, {
                project_key : this.project_key,
                issue_type  : this.issue_type
            });

            // unset empty option
            _.each(form_data, function(data, key) {
                if (data === '') {
                    delete form_data[key];
                }
            });

            if (form_data.assignee === 'auto') {
                form_data.assignee = -1;
            } else if (form_data.assignee === 'unassigned') {
                form_data.assignee = '';
            }

            this.$el.find('button[type="submit"]').prop('disabled', true).addClass('loading');

            this.$el.find('.mask-light').show();
            this.$el.find('.progress-loader').width('0%').show();
            var progress = 0;
            var timeout = setInterval(function() {
                progress = Math.min(90, progress + Math.random() * 5);
                this.$el.find('.progress-loader').width(progress + '%');
            }.bind(this), 50);

            Cache.app.request({
                action: 'integration/sendFeedbackToJira',
                context: this,
                data: {
                    feedback_id : this.model.get('id'),
                    project_key : this.project_key,
                    issue_type  : this.issue_type,
                    fields      : form_data
                },
                success: function(response) {
                    this.model.set('jira_url', response.jira_url);

                    setTimeout(function() {
                        UI.success('Issue created in Jira');
                        this.trigger('submit:success');
                    }.bind(this), 800);  // wait for animation to finish
                },
                complete: function() {
                    this.$el.find('button[type="submit"]').prop('disabled', false).removeClass('loading');

                    clearInterval(timeout);
                    this.$el.find('.progress-loader').width('100%');
                }
            });
        }
    },

    initialize: function() {
        this.form_value  = {
            summary: '',
            description: ''
        };

        if (this.model.isDesign() || this.model.isPdf() || this.model.isVideoUpload()) {
            this.form_value.summary = 'Feedback for ' + this.model.get('page');
        } else {
            this.form_value.summary = 'Feedback #' + Util.padLeft(this.model.id, '000000');
        }

        if (this.model.get('title')) {
            this.form_value.summary = this.model.get('title');
        }

        this.fields = {};
    },

    loadOptions: function() {
        var cache_key = 'jira_send_options_' + Cache.integration_jira.findWhere({project_id: this.model.get('project_id')})?.get('jira_host') || '';

        if (Cache.get(cache_key)) {
            this.loadOptionsSuccess(Cache.get(cache_key));
        } else {
            Cache.app.request({
                action: 'integration/loadSendOptions',
                data: {
                    type: 'jira',
                    project_id: this.model.get('project_id')
                },
                context: this,
                success: function(response) {
                    if (_.size(response.projects)) {
                        Cache.add(cache_key, response, false);
                        this.loadOptionsSuccess(response);
                    } else {
                        var message = '<div class="error-dialog padding-60">' +
                                            '<div class="icon"><i class="fas fa-exclamation"></i></div>' +
                                            '<h3>No projects found</h3>' +
                                            '<p class="info">We couldn\'t find any projects in your Jira account.</p>' +
                                            (Cache.app.isAdmin() ?
                                            '<button class="reconnect primary medium">Reconnect Jira</button>' +
                                            '<div class="divider-20"></div>' : '') +
                                        '</div>';

                        this.$el.html(message);
                    }
                },
                error: function() {
                    var message = '<div class="error-dialog padding-60">' +
                                        '<div class="icon"><i class="fas fa-exclamation"></i></div>' +
                                        '<h3>Authentication failed</h3>' +
                                        '<p class="info">We couldn\'t connect to your Jira host <b>' + (Cache.integration_jira.findWhere({project_id: this.model.get('project_id')})?.get('jira_host') || '') + '</b>. Please reconnect your Jira account.</p>' +
                                        (Cache.app.isAdmin() ?
                                        '<button class="reconnect primary medium">Reconnect Jira</button>' +
                                        '<div class="divider-20"></div>' : '') +
                                    '</div>';

                    this.$el.html(message);
                }
            });
        }
    },

    loadFields: function() {
        var cache_key = 'jira_field_options_' + (Cache.integration_jira.findWhere({project_id: this.model.get('project_id')})?.get('jira_host') || '') + '_' + this.project_key + '_' + this.issue_type;

        if (Cache.get(cache_key)) {
            this.loadFieldsSuccess(Cache.get(cache_key));
        } else {
            Cache.app.request({
                action: 'integration/loadSendOptions',
                data: {
                    type        : 'jira_fields',
                    project_id  : this.model.get('project_id'),
                    project_key : this.project_key,
                    issue_type  : this.issue_type
                },
                context: this,
                success: function(response) {
                    Cache.add(cache_key, response, false);
                    this.loadFieldsSuccess(Cache.get(cache_key));
                }
            });
        }
    },

    loadOptionsSuccess: function(response) {
        var default_project_key = Cache.integration_jira.findWhere({project_id: this.model.get('project_id')})?.get('project_key') || '';
        var default_issue_type  = Cache.integration_jira.findWhere({project_id: this.model.get('project_id')})?.get('issue_type')  || '';

        var project_keys = _.keys(response.projects);

        this.send_options = response;
        this.project_key  = project_keys.indexOf(default_project_key) === -1 ? project_keys[0] : default_project_key;
        this.issue_type   = this.searchIssueType(this.project_key, default_issue_type) ? this.searchIssueType(this.project_key, default_issue_type)['name'] : response.projects[this.project_key].issueTypes[0].name;

        this.createFieldViews();
        this.render();
    },

    loadFieldsSuccess: function(response) {
        this.fields[this.project_key + '_' + this.issue_type] = response;

        this.createFieldViews();
        this.render();
    },

    createFieldViews: function() {
        _.each(this.views.fields, function(view) {
            view.remove();
        });

        this.views.fields = {};

        var priority_field    = this.searchSystemField(this.project_key, this.issue_type, 'priority');
        var reporter_field    = this.searchSystemField(this.project_key, this.issue_type, 'reporter');
        var assignee_field    = this.searchSystemField(this.project_key, this.issue_type, 'assignee');
        var labels_field      = this.searchSystemField(this.project_key, this.issue_type, 'labels');
        var components_field  = this.searchSystemField(this.project_key, this.issue_type, 'components');
        var environment_field = this.searchSystemField(this.project_key, this.issue_type, 'environment');

        if (priority_field) {
            this.views.fields[priority_field.key] = new Jira_Field_Select({
                field: priority_field,
                value_key: 'id'
            });
        }

        if (reporter_field && this.send_options.users.length) {
            var allowed_values = [];
            var default_index  = 0;
            this.send_options.users.forEach(function(user, key) {
                allowed_values.push({
                    id        : user.accountId,
                    value     : user.displayName,
                    avatarUrl : user.avatarUrl
                });

                if (Cache.integration_jira.findWhere({project_id: this.model.get('project_id')}).get('reporter') && user.accountId === Cache.integration_jira.findWhere({project_id: this.model.get('project_id')}).get('reporter')) {
                    default_index = key;
                }
            }.bind(this));

            this.views.fields[reporter_field.key] = new Jira_Field_Select({
                field: _.extend(reporter_field, {
                    allowedValues: allowed_values,
                    defaultValue: allowed_values[default_index]
                }),
                value_key: 'id'
            });
        }

        if (assignee_field) {
            var allowed_values = [
                {
                    id        : 'auto',
                    value     : 'Automatic',
                    avatarUrl : '/image/profile.png'
                },
                {
                    id        : 'unassigned',
                    value     : 'Unassigned',
                    avatarUrl : '/image/profile.png'
                }
            ];
            this.send_options.users.forEach(function(user) {
                allowed_values.push({
                    id        : user.accountId,
                    value     : user.displayName,
                    avatarUrl : user.avatarUrl
                });
            }.bind(this));

            this.views.fields[assignee_field.key] = new Jira_Field_Select({
                field: _.extend(assignee_field, {
                    allowedValues: allowed_values,
                    defaultValue: allowed_values[0]
                }),
                value_key: 'id'
            });
        }

        if (components_field) {
            this.views.fields[components_field.key] = new Jira_Field_Array({
                field: components_field,
                value_key: 'id'
            });
        }

        if (environment_field) {
            this.views.fields[environment_field.key] = new Jira_Field_String({
                field: environment_field
            });
        }

        if (labels_field) {
            var labels = this.model.get('category') ? this.model.get('category').split(',') : [];
            var allowed_values = [];
            var default_value  = [];

            Cache.feedback_category.where({project_id: this.model.get('project_id')}).forEach(function(model) {
                var value_item = {
                    id: model.get('name').replace(/\s/g, ''),
                    value: model.get('name').replace(/\s/g, '')
                };

                if (labels.indexOf(model.get('name')) !== -1) {
                    default_value.push(value_item);
                }

                allowed_values.push(value_item);
            }.bind(this));

            this.views.fields[labels_field.key] = new Jira_Field_Array({field: _.extend(labels_field, {
                allowedValues: allowed_values,
                defaultValue: default_value
            })});
        }

        this.getNonSystemFields(this.project_keys, this.issue_type).forEach(function(field) {
            switch (field.schema.type) {
                case 'option':
                    if (field.allowedValues && field.allowedValues.length) {
                        this.views.fields[field.key] = new Jira_Field_Select({field: field});
                    }

                    break;
                case 'array':
                    if (field.allowedValues && field.allowedValues.length) {
                        this.views.fields[field.key] = new Jira_Field_Array({field: field});
                    } else if (field.schema.items === 'user') {
                        var allowed_values = [];
                        this.send_options.users.forEach(function(user) {
                            allowed_values.push({
                                id        : user.accountId,
                                value     : user.displayName,
                                avatarUrl : user.avatarUrl
                            });
                        }.bind(this));

                        this.views.fields[field.key] = new Jira_Field_Array({
                            field: _.extend(field, {
                                allowedValues: allowed_values
                            }),
                            value_key: 'id'
                        });
                    } else if (field.schema.items === 'string') {
                        this.views.fields[field.key] = new Jira_Field_String({field: field});
                    }

                    break;
                case 'string':
                    this.views.fields[field.key] = new Jira_Field_String({field: field});
                    break;
                case 'number':
                    this.views.fields[field.key] = new Jira_Field_Number({field: field});
                    break;
                case 'user':
                    if (this.send_options.users.length) {
                        var allowed_values = [];
                        this.send_options.users.forEach(function(user) {
                            allowed_values.push({
                                id        : user.accountId,
                                value     : user.displayName,
                                avatarUrl : user.avatarUrl
                            });
                        }.bind(this));

                        this.views.fields[field.key] = new Jira_Field_Select({
                            field: _.extend(field, {
                                allowedValues: allowed_values
                            }),
                            value_key: 'id'
                        });
                    }
                    break;
                case 'date':
                    var option = {field: field};
                    var name = field.name?.toLowerCase();
                    var due_date = this.model.get('due_date');
                    if ((name === 'duedate' || name === 'due date') && due_date) {
                        due_date = Util.moment(due_date, 'YYYY-MM-DD', false, false);
                        // add default value for due date to option
                        option.default_value = due_date;
                    }

                    this.views.fields[field.key] = new Jira_Field_Date(option);
                    break;
                case 'datetime':
                    this.views.fields[field.key] = new Jira_Field_Datetime({field: field});
                    break;
                default:
                    break;
            }
        }.bind(this));
    },

    searchProject: function(project_key) {
        if (this.send_options) {
            return this.send_options.projects[project_key];
        } else {
            return null;
        }
    },

    searchIssueType: function(project_key, issue_type) {
        var result = null;

        if (this.send_options) {
            this.send_options.projects[project_key].issueTypes.forEach(function(issue) {
                if (issue.name === issue_type) {
                    result = issue;
                }
            });
        }

        return result;
    },

    searchFieldByName: function(project_key, issue_type, field_name) {
        if (typeof this.fields[project_key + '_' + issue_type] !== 'undefined' &&
            typeof this.fields[project_key + '_' + issue_type][field_name] !== 'undefined') {

            return this.fields[project_key + '_' + issue_type][field_name];
        }

        return false;
    },

    searchSystemField: function(project_key, issue_type, name) {
        var result = false;

        if (typeof this.fields[project_key + '_' + issue_type] !== 'undefined') {
            _.each(this.fields[project_key + '_' + issue_type], function(field, field_name) {
                if (field.schema && field.schema.system === name) {
                    result = field;
                }
            });
        }

        return result;
    },

    searchPriorityItem: function(priority_field, name) {
        var result = false;

        if (this.send_options && this.send_options.priorities.length) {
            this.send_options.priorities.forEach(function(priority) {
                if (priority.name === name) {
                    result = priority;
                }
            });
        }

        return result;
    },

    getNonSystemFields: function(project_key, issue_type) {
        var fields = this.fields[this.project_key + '_' + this.issue_type];

        if (!fields) {
            return [];
        }

        var non_system_fields = [];

        _.each(fields, function(field, field_name) {
            if (this.system_fields.indexOf(field_name) === -1 &&
                this.system_fields_hidden.indexOf(field_name) === -1 &&
                (!field.schema || !field.schema.system || (this.system_fields.indexOf(field.schema.system) === -1 && this.system_fields_hidden.indexOf(field.schema.system) === -1))) {

                non_system_fields.push(field);
            }
        }, this);

        return non_system_fields;
    },

    render: function() {
        var content = '';

        var project_items    = '';
        var issue_type_items = '';

        if (this.send_options) {
            // projects
            _.each(this.send_options.projects, function(project, project_key) {
                project_items += '<li data-key="' + Util.htmlEntities(project_key) + '"' + (project_key === this.project_key ? ' class="active"' : '') + '>' +
                                        '<img class="icon-img" src="' + project.avatarUrl + '">' +
                                        Util.htmlEntities(project.name) +  '(' + Util.htmlEntities(project_key) + ')' +
                                    '</li>';
            }.bind(this));

            // issue type
            this.send_options.projects[this.project_key].issueTypes.forEach(function(issue_type) {
                issue_type_items += '<li data-name="' + Util.htmlEntities(issue_type.name) + '"' + (issue_type.name === this.issue_type ? ' class="active"' : '') + '>' +
                                        '<img class="icon-img" src="' + issue_type.iconUrl + '">' +
                                        Util.htmlEntities(issue_type.name) +
                                    '</li>';
            }.bind(this));
        }

        var project    = this.searchProject(this.project_key);
        var issue_type = this.searchIssueType(this.project_key, this.issue_type);

        var summary_field  = this.searchSystemField(this.project_key, this.issue_type, 'summary');
        var priority_field = this.searchSystemField(this.project_key, this.issue_type, 'priority');

        var is_field_loaded = this.fields[this.project_key + '_' + this.issue_type];

        content += '<div class="progress-loader"></div>';
        content += '<div class="mask-light" style="display:none;"></div>';

        content += '<form class="form-fluid">' +
                        '<div class="modal-integration-innerscroll">' +
                            '<div class="row-50">' +
                                '<div>' +
                                    '<div class="field-label">Project <i class="fas fa-asterisk"></i></div>' +
                                    (project ?
                                    '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-projects" data-append="true">' +
                                        '<button type="button" class="dropdown-select"><img class="icon-img" src="' + project.avatarUrl + '">' + Util.htmlEntities(project.name) +  '(' + Util.htmlEntities(this.project_key) + ')</button>' +
                                        '<div>' +
                                            '<div class="dropdown-search">' +
                                                '<input type="text" class="solid compact" placeholder="Search by project name">' +
                                            '</div>' +
                                            '<ul class="dropdown">' + project_items + '</ul>' +
                                        '</div>' +
                                    '</div>' : '<div class="loader-placeholder-medium"></div>') +
                                '</div>' +
                                '<div>' +
                                    '<div class="field-label">Issue Type <i class="fas fa-asterisk"></i></div>' +
                                    (issue_type ?
                                    '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-issue-types" data-append="true">' +
                                        '<button type="button" class="dropdown-select"><img class="icon-img" src="' + issue_type.iconUrl + '">' + Util.htmlEntities(issue_type.name)  + '</button>' +
                                        '<div>' +
                                            '<ul class="dropdown">' + issue_type_items + '</ul>' +
                                        '</div>' +
                                    '</div>' : '<div class="loader-placeholder-medium"></div>') +
                                '</div>' +
                            '</div>' +

                            (is_field_loaded ?

                            (summary_field ?
                            '<div class="row">' +
                                '<div class="field-label">Summary</div>' +
                                '<input type="text" name="summary" maxlength="255" class="solid compact">' +
                            '</div>' : '') +

                            '<div class="row">' +
                                '<div class="field-label">Description</div>' +
                                '<textarea name="description" class="solid compact" rows="3"></textarea>' +
                            '</div>'

                            :

                            '<div class="loader-placeholder margin-bottom-8" style="width:100px;"></div>' +
                            '<div class="loader-placeholder-medium margin-bottom-20"></div>' +
                            '<div class="loader-placeholder margin-bottom-8" style="width:100px;"></div>' +
                            '<div class="loader-placeholder-large margin-bottom-20"></div>' +
                            '<div class="loader-placeholder margin-bottom-8" style="width:100px;"></div>' +
                            '<div class="loader-placeholder-medium margin-bottom-20"></div>' +
                            '<div class="loader-placeholder margin-bottom-8" style="width:100px;"></div>' +
                            '<div class="loader-placeholder-medium margin-bottom-20"></div>' +
                            '<div class="loader-placeholder margin-bottom-8" style="width:100px;"></div>' +
                            '<div class="loader-placeholder-medium margin-bottom-20"></div>'

                            ) +
                        '</div>' +
                        '<div class="modal-integration-innerscroll-footer">' +
                            '<button type="submit" class="primary"' + (is_field_loaded ? '' : ' disabled') + '>Send</button>' +
                        '</div>' +
                    '</form>';

        this.$el.html(content);

        _.each(this.views.fields, function(view) {
            view.render().$el.appendTo(this.$el.find('.modal-integration-innerscroll'));
        }, this);

        if (!this.send_options) {
            this.loadOptions();
        }

        if (this.project_key && this.issue_type && !this.fields[this.project_key + '_' + this.issue_type]) {
            this.loadFields();
        }

        if (this.form_value.summary) {
            Form.setData(this.$el.find('form'), {
                summary: this.form_value.summary
            });
        }

        if (this.form_value.description) {
            Form.setData(this.$el.find('form'), {
                description: this.form_value.description
            });
        }

        return this;
    }
});

// single select
var Jira_Field_Select = View.extend({
    className: 'row',

    selected_value: '',

    events: {
        'click .dropdown li': 'onSelect'
    },

    dom_handlers: {
        onSelect: function(e) {
            this.selected_value = $(e.currentTarget).data('id');
            this.render();
        }
    },

    initialize: function(options) {
        this.field          = options.field;
        this.use_name       = !!options.use_name;
        this.value_key      = options.value_key || 'value';
        this.selected_value = this.field.defaultValue ? this.field.defaultValue.id : '';
    },

    searchOptionById: function(id) {
        var result = false;

        this.field.allowedValues.forEach(function(option) {
            if (option.id == id) {
                result = option;
            }
        });

        return result;
    },

    render: function() {
        var content = '';

        var items = '';

        this.field.allowedValues.forEach(function(item) {
            items += '<li data-id="' + item.id + '"' + (this.field.defaultValue && this.field.defaultValue.id === item.id ? ' class="active"' : '') + '>';

            if (item.iconUrl) {
                items += '<img class="icon-img" src="' + item.iconUrl + '">';
            } else if (item.avatarUrl) {
                items += '<img class="icon-img icon-img-round" src="' + item.avatarUrl + '">';
            }

            items +=     Util.htmlEntities(item.name || item.value);
            items += '</li>';
        }.bind(this));

        var selected_field = this.searchOptionById(this.selected_value);
        var selected_value = '';

        if (selected_field) {
            selected_value = selected_field[this.value_key] || selected_field.value || selected_field.name;
        }

        content += '<div class="field-label">' + Util.htmlEntities(this.field.name) + (this.field.required ? ' <i class="fas fa-asterisk"></i>' : '') + '</div>' +
                    '<div class="button-dropdown button-dropdown-full button-dropdown-left" data-append="true">' +
                        '<button type="button" class="dropdown-select">';

        if (selected_field) {
            if (selected_field.iconUrl) {
                content += '<img class="icon-img" src="' + selected_field.iconUrl + '">';
            } else if (selected_field.avatarUrl) {
                content += '<img class="icon-img icon-img-round" src="' + selected_field.avatarUrl + '">';
            }

            content += Util.htmlEntities(selected_field.name || selected_field.value || '');
        }

        content +=     '</button>' +
                        '<div>' +
                            '<div class="dropdown-search">' +
                                '<input type="text" class="solid compact" placeholder="Search">' +
                            '</div>' +
                            '<ul class="dropdown">' + items + '</ul>' +
                        '</div>' +
                        '<input type="hidden" name="' + this.field.key + '" value="' + Util.htmlEntities(selected_value) + '">' +
                    '</div>';

        this.$el.html(content);

        return this;
    }
});

// multiple select
var Jira_Field_Array = View.extend({
    className: 'row',

    selected_options: [],

    events: {
        'click .dropdown li': 'onSelect'
    },

    dom_handlers: {
        onSelect: function(e) {
            if ($(e.currentTarget).hasClass('disabled')) {
                return;
            }

            var id = $(e.currentTarget).data('id').toString();
            var is_selected = this.selected_options.indexOf(id) !== -1;

            if (is_selected) {
                this.selected_options.splice(this.selected_options.indexOf(id), 1);
            } else {
                this.selected_options.push(id);
            }

            this.render();
        }
    },

    initialize: function(options) {
        this.field     = options.field;
        this.value_key = options.value_key || 'value';

        this.selected_options = [];
        if (Array.isArray(this.field.defaultValue)) {
            this.field.defaultValue.forEach(function(option) {
                this.selected_options.push(option.id);
            }.bind(this));
        }
    },

    searchOptionById: function(id) {
        var result = false;

        this.field.allowedValues.forEach(function(option) {
            if (option.id == id) {
                result = option;
            }
        });

        return result;
    },

    render: function() {
        var content = '';

        var items = '';
        var default_display = '';

        this.selected_options.forEach((id) => {
            var option = this.searchOptionById(id);
            var option_value = option[this.value_key] || option.value || option.name;

            if (option) {
                default_display += '<span class="badge-secondary-invert">';

                if (option.iconUrl) {
                    default_display += '<img class="icon-img" src="' + option.iconUrl + '">';
                } else if (option.avatarUrl) {
                    default_display += '<img class="icon-img icon-img-round" src="' + option.avatarUrl + '">';
                }

                default_display +=     '<span>' + Util.htmlEntities(option.value || option.name) + '</span>' +
                                    '</span>' +
                                    '<input type="checkbox" class="hidden" name="' + this.field.key + '" value="' + Util.htmlEntities(option_value) + '" checked>';
            }
        });

        this.field.allowedValues.forEach(function(item) {
            var is_selected = this.selected_options.indexOf(item.id) !== -1;

            items += '<li data-id="' + item.id + '"' + (is_selected ? ' class="selected"' : '') + '>';

            if (item.iconUrl) {
                items += '<img class="icon-img" src="' + item.iconUrl + '">';
            } else if (item.avatarUrl) {
                items += '<img class="icon-img icon-img-round" src="' + item.avatarUrl + '">';
            }

            items += Util.htmlEntities(item.value || item.name);
            items += '</li>';
        }.bind(this));

        if (items === '') {
            items = '<li class="disabled">No matches</li>';
        }

        content += '<div class="row">' +
                        '<div class="field-label">' + Util.htmlEntities(this.field.name) + (this.field.required ? ' <i class="fas fa-asterisk"></i>' : '') + '</div>' +
                        '<div class="button-dropdown button-dropdown-full button-dropdown-left" data-append="true">' +
                            '<button type="button" class="dropdown-select dropdown-select-multiple">' + default_display + '</button>' +
                            '<div>' +
                                '<div class="dropdown-search">' +
                                    '<input type="text" class="solid compact" placeholder="Search">' +
                                '</div>' +
                                '<ul class="dropdown dropdown-select">' + items + '</ul>' +
                            '</div>' +
                        '</div>' +
                    '</div>';

        this.$el.html(content);

        return this;
    }
});

// single / multiline text
var Jira_Field_String = View.extend({
    className: 'row',

    initialize: function(options) {
        this.field = options.field;
    },

    render: function() {
        var content = '';

        content += '<div class="field-label">' + Util.htmlEntities(this.field.name) + (this.field.required ? ' <i class="fas fa-asterisk"></i>' : '') + '</div>';

        if (this.field.schema && this.field.schema.custom && this.field.schema.custom.search(':textarea') !== -1) {
            content += '<textarea name="' + this.field.key + '" class="solid compact" rows="4"' + (this.field.required ? ' required' : '') + '></textarea>';
        } else if (['environment'].includes(this.field.schema.system)) {
            content += '<textarea name="' + this.field.key + '" class="solid compact" rows="4"' + (this.field.required ? ' required' : '') + '></textarea>';
        } else if (this.field.schema && this.field.schema.custom && this.field.schema.custom.search(':url') !== -1) {
            content += '<input type="url" name="' + this.field.key + '" class="solid compact"' + (this.field.required ? ' required' : '') + '>';
        } else {
            content += '<input type="text" name="' + this.field.key + '" class="solid compact"' + (this.field.required ? ' required' : '') + '>';
        }

        this.$el.html(content);

        return this;
    }
});

// number
var Jira_Field_Number = View.extend({
    className: 'row',

    initialize: function(options) {
        this.field = options.field;
    },

    render: function() {
        var content = '';

        content += '<div class="field-label">' + Util.htmlEntities(this.field.name) + (this.field.required ? ' <i class="fas fa-asterisk"></i>' : '') + '</div>' +
                    '<input type="number" name="' + this.field.key + '" class="solid compact"' + (this.field.required ? ' required' : '') + '>';

        this.$el.html(content);

        return this;
    }
});

// date
var Jira_Field_Date = View.extend({
    className: 'row',

    initialize: function(options) {
        this.field = options.field;
        this.default_value = options.default_value;
    },

    render: function() {
        var content = '';

        content += '<div class="field-label">' + Util.htmlEntities(this.field.name) + (this.field.required ? ' <i class="fas fa-asterisk"></i>' : '') + '</div>' +
                    '<input type="date" name="' + this.field.key + '" class="solid compact"' + (this.field.required ? ' required' : '') + ' value="' + (this.default_value ? this.default_value : '') + '">';

        this.$el.html(content);

        return this;
    }
});

// datetime
var Jira_Field_Datetime = View.extend({
    className: 'row-50',

    events: {
        'change input': 'update'
    },

    dom_handlers: {
        update: function(e) {
            var date = this.$el.find('input[type="date"]').val();
            var time = this.$el.find('input[type="time"]').val();

            time = time || '00:00';

            if (date) {
                this.$el.find('input[type="hidden"]').val(date + ' ' + time);
            }
        }
    },

    initialize: function(options) {
        this.field = options.field;
    },

    render: function() {
        var content = '';

        content += '<div>'+
                        '<div class="field-label">' + Util.htmlEntities(this.field.name) + (this.field.required ? ' <i class="fas fa-asterisk"></i>' : '') + '</div>' +
                        '<input type="date" class="solid compact"' + (this.field.required ? ' required' : '') + '>' +
                    '</div>' +
                    '<div>' +
                        '<div class="field-label"></div>' +
                        '<input type="time" value="00:00" class="solid compact"' + (this.field.required ? ' required' : '') + '>' +
                    '</div>' +
                    '<input type="hidden" name="' + this.field.key + '">';

        this.$el.html(content);

        return this;
    }
});

export default Jira_Send;